import { shuffle } from 'lodash';

type MaxDiffType<T> = Map<string, { count: number; item: T }>;

const getScreenFn = () => {
  const caches: string[] = [];
  return function fn<T>(maxDiffMap: MaxDiffType<T>, answersOnScreen: number, recall = 0) {
    const screen = shuffle(Array.from(maxDiffMap.entries()))
      .sort((a, b) => a[1].count - b[1].count)
      .slice(0, answersOnScreen);

    const screenCache = Array.from(screen.values())
      .map(([id]) => id)
      .sort()
      .join(' ');

    if (caches.includes(screenCache) && recall < 10) return fn(maxDiffMap, answersOnScreen, recall + 1);

    caches.push(screenCache);
    screen.forEach(([, item]) => item.count++);
    return screen;
  };
};

export function generateScreens<T extends { id: string }>(
  answers: T[],
  answersOnScreen: number,
  numberOfScreens: number,
) {
  const maxDiffMap: MaxDiffType<T> = new Map();
  answers.forEach(item => maxDiffMap.set(item.id, { count: 0, item }));

  const getScreen = getScreenFn();

  const result: T[][] = [];
  for (let i = 0; i < numberOfScreens; i++) {
    const screen = getScreen(maxDiffMap, answersOnScreen);
    result.push(screen.map(([, { item }]) => item));
  }
  return result;
}
